<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title" style="position: relative">
      <h1>User Details</h1>

      <form [formGroup]="userForm" (ngSubmit)="saveForm(userForm.value)" autocomplete="off">
        <div class="ui-grid ui-grid-responsive ui-fluid">
          <div class="ui-g-12">
            <div class="ui-g-2 ui-sm-4"><label for="email">Email Address</label></div>
            <div class="ui-g-4 ui-sm-8">
              <input
                pInputText
                id="email"
                formControlName="email"
                maxlength="254"
                class="form-component"
              />
            </div>
          </div>

          <div
            class="ui-g-12"
            *ngIf="
              (orgType == 1 && oldUser && oldUser.organisation.organisationTypeId == 2) ||
              orgType == 2 ||
              orgType == 4
            "
          >
            <div class="ui-g-2 ui-sm-4">
              <label for="sendOrderConfirmationEmail">Send user order confirmation email</label>
            </div>
            <div class="ui-g-4 ui-sm-8">
              <p-checkbox
                id="sendOrderConfirmationEmail"
                formControlName="sendOrderConfirmationEmail"
                binary="true"
              ></p-checkbox>
            </div>
          </div>

          <div class="ui-g-12">
            <div class="ui-g-2 ui-sm-4 ui-sm-12">
              <label for="phoneNumber">Telephone Number</label>
            </div>
            <div class="ui-g-4 ui-sm-8 ui-sm-12">
              <input
                type="tel"
                pInputText
                id="phoneNumber"
                formControlName="phoneNumber"
                maxlength="20"
                trim
                class="form-component"
              />
            </div>
          </div>

          <div class="ui-g-12">
            <div class="ui-g-2 ui-sm-4"><label for="firstName">First Name</label></div>
            <div class="ui-g-4 ui-sm-8">
              <input
                pInputText
                id="firstName"
                formControlName="firstName"
                maxlength="100"
                class="form-component"
              />
            </div>
          </div>

          <div class="ui-g-12">
            <div class="ui-g-2 ui-sm-4"><label for="lastName">Last Name</label></div>
            <div class="ui-g-4 ui-sm-8">
              <input
                pInputText
                id="lastName"
                formControlName="lastName"
                maxlength="100"
                class="form-component"
              />
            </div>
          </div>

          <div class="ui-g-12" *ngIf="isVmeUser">
            <div class="ui-g-2 ui-sm-4"><label for="sdGroup">Service Delivery Group</label></div>
            <div class="ui-g-4 ui-sm-8">
              <p-dropdown
                id="sdGroup"
                name="selectedServiceGroup"
                [options]="serviceDeliveryGroups"
                [style]="{ width: '100%' }"
                formControlName="serviceDeliveryGroupId"
              ></p-dropdown>
            </div>
          </div>

          <div
            *ngIf="(selectedOrgData && selectedOrgData.twoFactorStatus == 2) || userOrgTypeId == 1"
            class="ui-g-12"
          >
            <div class="ui-g-2 ui-sm-4"><label for="name">Two Factor Required</label></div>
            <div class="ui-g-4 ui-sm-8">
              <p-checkbox
                id="twoFactorRequired"
                formControlName="twoFactorRequired"
                binary="true"
                [disabled]="disableTwoFactorRequiredField"
              ></p-checkbox>
            </div>
          </div>

          <!--<div class="ui-g-12" *ngIf="orgType == 1">
        <div class="ui-g-2"><label for="organisationId">Organisation</label></div>
        <div class="ui-g-4">
            <p-dropdown name="organisationId" [options]="organisations" formControlName="organisationId"
                        [(ngModel)]="selectedOrg" [filter]="true" filterBy="label"
                        (onChange)="orgChange($event)" styleClass="form-component"></p-dropdown>
        </div>
    </div>-->

          <div class="ui-g-12" *ngIf="selectedOrg">
            <div class="ui-g-2 ui-sm-12"><label for="userRoles">Roles</label></div>
            <div class="ui-g-4 ui-sm-12">
              <p-listbox
                name="userRoles"
                [options]="roles"
                formControlName="userRoles"
                multiple="multiply"
                (onChange)="rolesChange()"
                checkbox="checkbox"
                [metaKeySelection]="false"
                [(ngModel)]="selectedRoles"
                styleClass="form-component"
              >
              </p-listbox>
              <div *ngIf="cannotEditOwnRoles" class="own-roles-note form-component">
                <i class="fa fa-lock"></i>
                <span
                  >You cannot update your own roles. Please ask another account administrator to
                  change them for you.</span
                >
              </div>
            </div>
          </div>

          <div class="ui-g-12">
            <div class="ui-g-2 ui-sm-4"><label for="jobTitle">Job Title</label></div>
            <div class="ui-g-4 ui-sm-8">
              <input
                pInputText
                id="jobTitle"
                formControlName="jobTitle"
                maxlength="100"
                class="form-component"
              />
            </div>
          </div>

          <div [ngClass]="{ hidden: isNew }" class="ui-g-12">
            <div class="ui-g-2 ui-sm-4"><label for="name">Profile Image</label></div>
            <div class="ui-g-4 ui-sm-8">
              <div class="form-component">
                <p-fileUpload
                  name="files"
                  url="/api/users/{{ userId }}/updateProfileImage"
                  #pUploader
                  (onBeforeUpload)="onBeforeProfileImageUpload($event)"
                  (onUpload)="onProfileImageUpload($event)"
                  (onSelect)="onSelectProfileImage($event)"
                  (onError)="onProfileImageUploadError($event)"
                  (onClear)="onClearProfileImage()"
                  cancelLabel="Revert"
                  [showUploadButton]="false"
                  withCredentials="true"
                  [showCancelButton]="profileImageChanged()"
                  [maxFileSize]="83886080"
                  accept="application/pdf,image/*"
                >
                  <ng-template let-file pTemplate="file">
                    <div class="w-full text-center">
                      <p-avatar
                        *ngIf="profileImageUploaded; else elseBlock"
                        shape="circle"
                        styleClass="xxlarge"
                        [image]="userForm.value.profileImageUrl"
                        [label]="userForm.value.initials"
                      ></p-avatar>
                      <ng-template #elseBlock>
                        <p-avatar
                          shape="circle"
                          styleClass="xxlarge"
                          [image]="uploadedFileSrc"
                          [label]="userForm.value.initials"
                        ></p-avatar>
                      </ng-template>
                      <div class="delete-icon" (click)="deleteImage()" *ngIf="profileImageUploaded">
                        <i class="fa fa-times"></i>
                      </div>
                    </div>
                  </ng-template>
                </p-fileUpload>
              </div>
            </div>
          </div>
          <!--<div formGroupName="userOrganisationLevel" *ngIf="selectedOrgData && (selectedOrgData.organisationTypeId == 2 || selectedOrgData.organisationTypeId == 4)">
        <div class="ui-g-12">
            <div class="ui-g-2">
                <label for="customerDepartmentId">Department</label>
            </div>
            <div class="ui-g-4">
                <p-dropdown [options]="departments" formControlName="customerDepartmentId"
                            (onChange)="departmentChange($event)"
                            [(ngModel)]="selectedDepartment"
                            name="customerDepartmentId" styleClass="form-component"></p-dropdown>
            </div>
        </div>

        <div class="ui-g-12" *ngIf="selectedDepartment!=null && teams.length > 0">
            <div class="ui-g-2">
                <label for="customerTeamId">Team</label>
            </div>
            <div class="ui-g-4">
                <p-dropdown [options]="teams" formControlName="customerTeamId" styleClass="form-component"
                            [(ngModel)]="selectedTeam" name="customerTeamId"></p-dropdown>
            </div>
        </div>
    </div>

    <div formGroupName="userOrganisationLevel" *ngIf="selectedOrgData && (selectedOrgData.organisationTypeId == 3 || selectedOrgData.organisationTypeId == 4)">
        <div class="ui-g-12">
            <div class="ui-g-2">
                <label for="supplierRegionId">Region</label>
            </div>
            <div class="ui-g-4">
                <p-dropdown [options]="regions" formControlName="supplierRegionId"
                            (onChange)="regionChange($event)"
                            styleClass="form-component" [(ngModel)]="selectedRegion"
                            name="supplierRegionId"></p-dropdown>
            </div>
        </div>

        <div class="ui-g-12" *ngIf="selectedRegion!=null && depots.length > 0">
            <div class="ui-g-2">
                <label for="supplierDepotId">Depot</label>
            </div>
            <div class="ui-g-4">
                <p-dropdown [options]="depots" formControlName="supplierDepotId" styleClass="form-component"
                            [(ngModel)]="selectedDepot" name="supplierDepotId"></p-dropdown>
            </div>
        </div>
    </div>-->

          <div
            *ngIf="
              selectedOrgData &&
              (selectedOrgData.organisationTypeId == 2 || selectedOrgData.organisationTypeId == 4)
            "
          >
            <div class="ui-g-12">
              <div class="ui-g-2 ui-sm-12">
                <label for="supplierDepotId">Team</label>
              </div>
              <div class="ui-g-4 ui-sm-12">
                <p-checkbox
                  label="All Teams"
                  binary="true"
                  [(ngModel)]="isAllTeams"
                  (onChange)="isAllTeamsChange($event)"
                  [style]="{ 'margin-bottom': '10px' }"
                  [ngModelOptions]="{ standalone: true }"
                ></p-checkbox>

                <org-tree
                  #orgTreeCustomer
                  [orgId]="selectedOrgData.id"
                  [orgType]="OrgType_Customer"
                  [selectedIds]="selectedTeam"
                  (selectedItemsChange)="selectedTeamsChange()"
                ></org-tree>
              </div>
            </div>
          </div>

          <div *ngIf="selectedTeams && selectedTeams.length != 0">
            <div class="ui-g-12">
              <div class="ui-g-2 ui-sm-4">
                <label for="selectedDefaultTeam">Default Team</label>
              </div>
              <div class="ui-g-4 ui-sm-8">
                <p-dropdown
                  id="selectedDefaultTeam"
                  name="selectedDefaultTeam"
                  [options]="selectedTeams"
                  [(ngModel)]="selectedDefaultTeam"
                  [style]="{ width: '100%' }"
                  [ngModelOptions]="{ standalone: true }"
                ></p-dropdown>
              </div>
            </div>
          </div>

          <div
            *ngIf="
              selectedOrgData &&
              (selectedOrgData.organisationTypeId == 3 || selectedOrgData.organisationTypeId == 4)
            "
          >
            <div class="ui-g-12">
              <div class="ui-g-2 ui-sm-12">
                <label for="supplierDepotId">Depot</label>
              </div>
              <div class="ui-g-4 ui-sm-12">
                <p-checkbox
                  label="All Depots"
                  binary="true"
                  [(ngModel)]="isAllDepots"
                  (onChange)="isAllDepotsChange($event)"
                  [style]="{ 'margin-bottom': '10px' }"
                  [ngModelOptions]="{ standalone: true }"
                ></p-checkbox>

                <org-tree
                  #orgTreeSupplier
                  [orgId]="selectedOrgData.id"
                  [orgType]="OrgType_Supplier"
                  [selectedIds]="selectedDepot"
                  (selectedItemsChange)="selectedDepotsChange()"
                ></org-tree>
              </div>
            </div>
          </div>

          <div *ngIf="selectedDepots && selectedDepots.length != 0">
            <div class="ui-g-12">
              <div class="ui-g-2 ui-sm-4">
                <label for="selectedDefaultDepot">Default Depot</label>
              </div>
              <div class="ui-g-4 ui-sm-8">
                <p-dropdown
                  id="selectedDefaultDepot"
                  name="selectedDefaultDepot"
                  [options]="selectedDepots"
                  [(ngModel)]="selectedDefaultDepot"
                  [style]="{ width: '100%' }"
                  [ngModelOptions]="{ standalone: true }"
                ></p-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <button
            type="button"
            (click)="cancel()"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button mt-1 ui-sm-12"
          ></button>
          <button
            type="submit"
            pButton
            icon="fa ui-icon-check"
            label="Invite"
            class="ui-button green-btn pull-right mt-1 ui-sm-12"
            [disabled]="!userForm.valid || isTeamSelectionInvalid"
            *ngIf="isNew"
          ></button>
          <button
            type="submit"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            class="ui-button green-btn pull-right mt-1 ui-sm-12"
            [disabled]="!userForm.valid || isTeamSelectionInvalid"
            *ngIf="!isNew"
          ></button>
          <button
            type="button"
            pButton
            label="Impersonate User"
            class="ui-button green-btn pull-right mt-1 ui-sm-12"
            (click)="impersonate()"
            [disabled]="!enableImpersonateBtn"
            *ngIf="!hideImpersonateBtn"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-refresh"
            label="Resend Invitation"
            class="ui-button green-btn pull-right mt-1 ui-sm-12"
            (click)="resendInvitation()"
            [disabled]="!userForm.valid || isTeamSelectionInvalid"
            *ngIf="!isNew"
          ></button>
        </div>
      </form>
      <div
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background: gray;
          opacity: 0.3;
        "
        *ngIf="isBusy"
      >
        <img
          src="assets/images/loader.gif"
          style="margin-left: 45%; margin-top: 10%"
          width="50"
          height="50"
          alt="load"
        />
      </div>
    </div>
    <div style="padding-top: 10px" *ngIf="travelPreferencesEnabled && orgType == 3">
      <algo-travel-preferences></algo-travel-preferences>
    </div>
  </div>
</div>

<!--<p-confirmDialog [(visible)]="confirmationDlg" header="Confirmation" icon="fa fa-question-circle" width="425" message="confirmsg">
    <div style="float:right;"></div>
    <p-footer>
        <button type="button" class="green-btn" style="width: auto;" pButton icon="fa ui-icon-check" label="Ok" (click)="goToUsersList()"></button>
    </p-footer>
</p-confirmDialog>-->
<p-dialog
  header="Confirmation"
  [(visible)]="confirmDlg"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-g-12">
      <label>{{ confirmsg }}</label>
    </div>
    <div class="ui-g-12"></div>
  </div>
  <div style="float: right">
    <button
      type="button"
      class="green-btn"
      pButton
      style="width: auto"
      (click)="goToUsersList()"
      icon="fa ui-icon-check"
      label="Ok"
    ></button>
  </div>
</p-dialog>
